import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../Firebase/config";

const getSafeFileName = (file) => {
  const originalName = file.name || `profile-${Date.now()}.jpg`;
  return `${Date.now()}-${originalName.replace(/[^a-zA-Z0-9._-]/g, "_")}`;
};

const uploadImage = async (file) => {
  if (!file) {
    throw new Error("No file provided");
  }

  const storageRef = ref(storage, `images/${getSafeFileName(file)}`);
  await uploadBytes(storageRef, file);
  const url = await getDownloadURL(storageRef);
  return url;
};

export { uploadImage };
